// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.mar-left {
  margin-left: 10px;
}

.mar-right {
  margin-right: 10px;
}

.usr-info {
  border-bottom: 1px dotted #d2d2d2;
}

.info-icon {
  padding-left: 30px;
  position: relative;
  margin-bottom: 0px;
}
.info-icon i {
  position: absolute;
  left: 0px;
  color: inherit;
}

.prod-unassign {
  padding-top: 20px;
}

.user-product-info {
  padding-bottom: 20px;
}

h1 {
  line-height: 34px;
  word-break: break-word;
}

.right {
  float: right;
}

.padding-top {
  padding-top: 20px;
}

.padding-margin-bottom {
  margin-bottom: 20px;
  padding-top: 20px;
}

.line-footer {
  margin-top: 30px;
}

.border-btm-solid {
  border-bottom: 1px solid #d2d2d2;
}

.item-list {
  border-bottom: 1px solid #d2d2d2;
  margin: 0;
}
.item-list:last-child {
  border-bottom: 0;
}

.item-info {
  margin-left: 0;
  padding-left: 0;
}

.assign-btn {
  padding: 30px 0;
}
.assign-btn button {
  float: right;
}

.bullet-list li {
  margin-top: 0;
}

.prod-catalog h4 {
  font: 1.6rem "Omnes-ATT-W02-Medium";
  margin-top: 20px;
}

.modal-header {
  padding: 30px;
  position: relative;
}
.modal-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0 !important;
  outline: none;
  padding: 0;
}
.modal-header #modalHeader {
  outline: none;
}

.modal-body {
  overflow: auto;
  padding: 0 30px 20px;
  position: relative;
  width: 100%;
}
.modal-body h6 {
  font-size: 2.5rem;
  margin: 0;
  padding: 0;
}
.modal-body p {
  margin-top: 0 !important;
}
.modal-body span {
  text-transform: capitalize;
}

.modal-footer {
  padding: 0 30px;
  position: relative;
  width: 100%;
}
.modal-footer .button-group {
  margin-bottom: 20px;
}
.modal-footer hr {
  margin-bottom: 20px;
  margin-top: 0;
}
.modal-footer button {
  margin-left: 20px;
}
.modal-footer a {
  margin-bottom: 20px;
}

.modal-message {
  padding-top: 10px;
}

.valign-children-middle {
  margin-top: 10px;
}

.prod-disable {
  color: #767676;
}
@keyframes animatetop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 1024px) {
  .main-container {
    margin: 5% 0 10%;
  }
  h1 {
    line-height: 24px;
  }
  .assign-btn button {
    float: none;
  }
  h2 {
    font-size: 18px !important;
  }
  .prod-unassign {
    padding: 0 0 20px;
  }
  .prod-unassign a {
    float: left;
  }
  .button-group {
    display: block;
    text-align: center;
  }
  .button-group .btn {
    display: block;
    float: none;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  .modal-body {
    padding: 0 17px 20px !important;
  }
  .modal-header {
    padding: 15px 46px 24px 17px !important;
  }
  .modal-footer {
    padding: 0 15px !important;
  }
  .modal-footer .btn {
    width: 100%;
  }
  .modal-footer a {
    margin-top: 20px;
  }
  .modal-footer .button-group {
    margin-bottom: 30px;
  }
  .modal-footer button {
    margin-left: 0 !important;
  }
  .modal-message {
    padding-top: 10px;
  }
  .box-outer {
    padding: 0 17px;
  }
  .line-footer {
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/user-summary/user-summary.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,iBAAA;AAkJF;;AA/IA;EACE,kBAAA;AAkJF;;AA/IA;EACE,iCAAA;AAkJF;;AA/IA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAkJF;AAjJE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;AAmJJ;;AA/IA;EACE,iBAAA;AAkJF;;AA/IA;EACE,oBAAA;AAkJF;;AA/IA;EACE,iBAAA;EACA,sBAAA;AAkJF;;AA/IA;EACE,YAAA;AAkJF;;AA/IA;EACE,iBAAA;AAkJF;;AA/IA;EACE,mBAAA;EACA,iBAAA;AAkJF;;AA/IA;EACE,gBAAA;AAkJF;;AA/IA;EACE,gCAAA;AAkJF;;AA/IA;EACE,gCAAA;EACA,SAAA;AAkJF;AAhJE;EACE,gBAAA;AAkJJ;;AA7IA;EACE,cAAA;EACA,eAAA;AAgJF;;AA5IA;EACE,eAAA;AA+IF;AA7IE;EACE,YAAA;AA+IJ;;AAxIE;EACE,aAAA;AA2IJ;;AAtIE;EACE,mCAAA;EACA,gBAAA;AAyIJ;;AArIA;EACE,aAAA;EACA,kBAAA;AAwIF;AAtIE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,UAAA;AAwIJ;AArIE;EACE,aAAA;AAuIJ;;AAnIA;EACE,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AAsIF;AApIE;EACE,iBAAA;EACA,SAAA;EACA,UAAA;AAsIJ;AAnIE;EACE,wBAAA;AAqIJ;AAlIE;EACE,0BAAA;AAoIJ;;AA9HA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAiIF;AA/HE;EACE,mBAAA;AAiIJ;AA9HE;EACE,mBAAA;EACA,aAAA;AAgIJ;AA7HE;EACE,iBAAA;AA+HJ;AA5HE;EACE,mBAAA;AA8HJ;;AA1HA;EACE,iBAAA;AA6HF;;AA1HA;EACE,gBAAA;AA6HF;;AAzHA;EACE,cAAA;AA4HF;AA7GA;EACE;IACE,UAAA;EAwHF;EArHA;IACE,UAAA;EAuHF;AACF;AFjSI;EE8KF;IACE,gBAAA;EAsHF;EAnHA;IACE,iBAAA;EAqHF;EAjHE;IACE,WAAA;EAmHJ;EA/GA;IACE,0BAAA;EAiHF;EA9GA;IACE,iBAAA;EAgHF;EA9GE;IACE,WAAA;EAgHJ;EA5GA;IACE,cAAA;IACA,kBAAA;EA8GF;EA5GE;IACE,cAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EA8GJ;EAzGA;IACE,+BAAA;EA2GF;EAxGA;IACE,uCAAA;EA0GF;EAvGA;IACE,0BAAA;EAyGF;EAvGE;IACE,WAAA;EAyGJ;EAtGE;IACE,gBAAA;EAwGJ;EArGE;IACE,mBAAA;EAuGJ;EApGE;IACE,yBAAA;EAsGJ;EAlGA;IACE,iBAAA;EAoGF;EAjGA;IACE,eAAA;EAmGF;EAhGA;IACE,gBAAA;EAkGF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.mar-left {\n  margin-left: 10px;\n}\n\n.mar-right {\n  margin-right: 10px;\n}\n\n.usr-info {\n  border-bottom: 1px dotted color(default, dark);\n}\n\n.info-icon {\n  padding-left: 30px;\n  position: relative;\n  margin-bottom: 0px;\n  i {\n    position: absolute;\n    left: 0px;\n    color: inherit;\n  }\n}\n\n.prod-unassign {\n  padding-top: 20px;\n}\n\n.user-product-info {\n  padding-bottom: 20px;\n}\n\nh1 {\n  line-height: 34px;\n  word-break: break-word;\n}\n\n.right {\n  float: right;\n}\n\n.padding-top {\n  padding-top: 20px;\n}\n\n.padding-margin-bottom {\n  margin-bottom: 20px;\n  padding-top: 20px;\n}\n\n.line-footer {\n  margin-top: 30px;\n}\n\n.border-btm-solid {\n  border-bottom: 1px solid color(default, dark);\n}\n\n.item-list {\n  border-bottom: 1px solid color(default, dark);\n  margin: 0;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n}\n\n\n.item-info {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n\n.assign-btn {\n  padding: 30px 0;\n\n  button {\n    float: right;\n  }\n}\n\n//model popup\n\n.bullet-list {\n  li {\n    margin-top: 0;\n  }\n}\n\n.prod-catalog {\n  h4 {\n    font: 1.6rem 'Omnes-ATT-W02-Medium';\n    margin-top: 20px;\n    }\n  }\n\n.modal-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0 !important;\n    outline: none;\n    padding: 0;\n  }\n\n  #modalHeader {\n    outline: none;\n  }\n}\n\n.modal-body {\n  overflow: auto;\n  padding: 0 30px 20px;\n  position: relative;\n  width: 100%;\n\n  h6 {\n    font-size: 2.5rem;\n    margin: 0;\n    padding: 0;\n  }\n\n  p {\n    margin-top: 0 !important;\n  }\n\n  span {\n    text-transform: capitalize;\n  }\n}\n\n\n\n.modal-footer {\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n\n  .button-group {\n    margin-bottom: 20px;\n  }\n\n  hr {\n    margin-bottom: 20px;\n    margin-top: 0;\n  }\n\n  button {\n    margin-left: 20px;\n  }\n\n  a {\n    margin-bottom: 20px;\n  }\n}\n\n.modal-message {\n  padding-top: 10px;\n}\n\n.valign-children-middle {\n  margin-top: 10px;\n}\n\n\n.prod-disable {\n  color: color(inverse, light);\n}\n\n// Add Animation\n\n@-webkit-keyframes animatetop { //TODO: Need to write common mixing function\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@include respond-to(small) {\n  .main-container {\n    margin: 5% 0 10%;\n  }\n\n  h1 {\n    line-height: 24px;\n  }\n\n  .assign-btn {\n    button {\n      float: none;\n    }\n  }\n\n  h2 {\n    font-size: 18px !important;\n  }\n\n  .prod-unassign {\n    padding: 0 0 20px;\n\n    a {\n      float: left;\n    }\n  }\n\n  .button-group {\n    display: block;\n    text-align: center;\n\n    .btn {\n      display: block;\n      float: none;\n      margin-left: auto;\n      margin-right: auto;\n      width: 100%;\n\n    }\n  }\n\n  .modal-body {\n    padding: 0 17px 20px !important;\n  }\n\n  .modal-header {\n    padding: 15px 46px 24px 17px !important;\n  }\n\n  .modal-footer {\n    padding: 0 15px !important;\n\n    .btn {\n      width: 100%;\n    }\n\n    a {\n      margin-top: 20px;\n     }\n\n    .button-group {\n      margin-bottom: 30px;\n     }\n\n    button {\n      margin-left: 0 !important;\n     }\n  }\n\n  .modal-message {\n    padding-top: 10px;\n  }\n\n  .box-outer {\n    padding: 0 17px;\n}\n\n  .line-footer {\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
